import { useState, useEffect, useCallback, useSyncExternalStore } from 'react'
import { http } from './http'

export type BackendStatus = 'checking' | 'connected' | 'degraded' | 'disconnected'

// Singleton — un seul intervalle partagé entre tous les composants
let _status: BackendStatus = 'checking'
let _listeners: Set<() => void> = new Set()
let _intervalId: ReturnType<typeof setInterval> | null = null

let notify = () => _listeners.forEach(l => l())

let doCheck = async () => {
  try {
    let res = await http.get('/health', { timeout: 5000 })
    _status = res.data?.firestore === 'connected' ? 'connected' : 'degraded'
  } catch {
    _status = 'disconnected'
  }
  notify()
}

let startPolling = () => {
  if (_intervalId) return
  doCheck()
  _intervalId = setInterval(doCheck, 60000)
}

let subscribe = (listener: () => void) => {
  _listeners.add(listener)
  if (_listeners.size === 1) startPolling()
  return () => {
    _listeners.delete(listener)
    if (_listeners.size === 0 && _intervalId) {
      clearInterval(_intervalId)
      _intervalId = null
    }
  }
}

let getSnapshot = () => _status

// Hook — tous les composants partagent le même polling
export function useBackendStatus() {
  let status = useSyncExternalStore(subscribe, getSnapshot)

  let recheck = useCallback(async () => {
    _status = 'checking'
    notify()
    await doCheck()
  }, [])

  return { status, recheck }
}
